import { crudController } from 'fc-controller'

import {
  URL,
  MODEL,
  TREE,
  BRANCH,
} from 'fc-model-fieldborder'

// Selectors
import token$ from 'fc-auth/src/selectors/token'

// Initialze
import initialize from './initialize'

// Controller
export default crudController({
  url: URL,
  model: MODEL,
  tree: TREE,
  branch: BRANCH,
  token$,
  initialize,
})
